import { merge } from 'lodash';
import Lists from './Lists';
import Paper from './Paper';
import Input from './Input';
import Button from './Button';
import Tooltip from './Tooltip';
import Backdrop from './Backdrop';
import Typography from './Typography';
import IconButton from './IconButton';
import Autocomplete from './Autocomplete';
import TableCell from './TableCell';
import Checkbox from './CheckBox';
import Tabs from './Tabs';


export default function ComponentsOverrides(theme) {
  return merge(
    Lists(theme),
    Paper(theme),
    Input(theme),
    Button(theme),
    Tooltip(theme),
    Backdrop(theme),
    Typography(theme),
    IconButton(theme),
    Autocomplete(theme),
    TableCell(theme),
    Checkbox(theme),
    Tabs(theme)
  );
}
